import './FooterEfLogo.scss'

import {Link} from '../../../util/link'
import {Picture} from '@codeurs/front'
import React from 'react'
import logoEF from 'assets/images/EF_logo.png'
import {style} from '../../../util/style'
import {useTranslation} from '../../../util/i18n'

const styles = style('footereflogo')

export const FooterEfLogo: React.FC<{}> = () => {
	const t = useTranslation('footer')

	return (
		<div className={styles()}>
			<Link to={t.ef.link} className={styles('link')}>
				<Picture
					{...logoEF}
					alt="EF logo"
					className={styles('link-logo').toString()}
				/>
			</Link>
		</div>
	)
}
